const quickLinksSelect = document.querySelector(".quick-links__select") as HTMLInputElement

if(quickLinksSelect){
  quickLinksSelect.addEventListener("change", e => {
    window.location.href=quickLinksSelect.value
  })
}